export default __webpack_public_path__ + "static/media/small-close-button.92420bfb.png";